import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useContract, useContractRead, useAddress } from "@thirdweb-dev/react";
import "../styles/staking.css";
import StakingBox1 from "../components/StakingBox1";
import StakingBox2 from "../components/StakingBox2";
import StakingBox3 from "../components/StakingBox3";
import StakingBox4 from "../components/StakingBox4";
import StakingSupply from "../components/StakingSupply";
import Bubble from "../components/Bubble";

const Staking = () => {
  const { t } = useTranslation();

  return (
    <>
      <h1 className="staking-title">{t('staking.page.title')}</h1>

      {/* Primera fila: Cajas de staking */}
      <div className="staking-container full-width-container">
        <StakingBox1 style={{ 
          position: 'relative', 
          top: '10px', /* Mueve hacia abajo */
          left: '5px', /* Mueve hacia la derecha */
          marginTop: '20px', /* Espacio superior */
          marginBottom: '10px' /* Espacio inferior */
        }} />
        <StakingBox2 />
        <StakingBox3 />
        <StakingBox4 />
      </div>

      {/* Contenedor flexible para StakingSupply - ajustado para permitir modificaciones */}
      <div className="staking-supply-wrapper" style={{ position: 'relative' }}>
        <StakingSupply />
      </div>

      {/* Placeholder debajo de StakingSupply - ajustado para permitir modificaciones */}
      <div className="staking-placeholder" style={{ position: 'relative' }}>
        <p>Este es un placeholder</p>
      </div>

      {/* Espacio adicional entre las cajas y las burbujas */}
      <div style={{ marginTop: '60px' }}></div>

      {/* Burbujas de información */}
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '60px', 
        padding: '15px',
        marginBottom: '40px'
      }}>
        {/* Primera fila: Burbujas 1 y 2 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <Bubble 
            title={t('bubbles.staking.platform.title')}
            content={t('bubbles.staking.platform.content')}
            color="blue"
            position="center"
            size="medium"
          />
          <Bubble 
            title={t('bubbles.staking.benefits.title')}
            content={
              <ul>
                {t('bubbles.staking.benefits.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            }
            color="green"
            position="center"
            size="medium"
          />
        </div>

        {/* Segunda fila: Burbuja 3 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <Bubble 
            title={t('bubbles.staking.rewards.title')}
            content={t('bubbles.staking.rewards.content')}
            color="orange"
            position="center"
            size="medium"
          />
        </div>
      </div>
    </>
  );
};

export default Staking;
